import {Capability} from 'auth/capabilities/CapabilityFeatureConstants';
import isCapabilityEnabledForTenant from 'auth/capabilities/isCapabilityEnabledForTenant';
import BenchlingConfig from 'BenchlingConfig';
import APIUtil from 'util/APIUtil';

/** Whether scratch plates may integrate with worksheets. */
export function isScratchPlateWorksheetIntegrationEnabled(): boolean {
  return (
    BenchlingConfig.ENABLE_SCRATCH_PLATES_WORKSHEET_INTEGRATION_GATING ||
    (BenchlingConfig.ENABLE_SCRATCH_PLATES &&
      // We currently do NOT support scratch plates in worksheets if the tenant has enabled BioA or BioP.
      !BenchlingConfig.SAMPLE_TESTS_ENABLE &&
      !(
        BenchlingConfig.IDENTITY_ENABLE_CAPABILITY_GATING && isCapabilityEnabledForTenant(Capability.ASSAYS)
      ) &&
      !(
        BenchlingConfig.IDENTITY_ENABLE_CAPABILITY_GATING && isCapabilityEnabledForTenant(Capability.RECIPES)
      ))
  );
}

/** Whether the scratch plate design is available for a plate map inserted into the given document. */
export function isScratchPlateDesignAvailableForDocument(documentId: string): boolean {
  if (!BenchlingConfig.ENABLE_SCRATCH_PLATES) {
    return false;
  }
  // isDocument is true for worksheet step documents (doc_), false for entries (etr_).
  if (APIUtil.isDocument(documentId)) {
    return isScratchPlateWorksheetIntegrationEnabled();
  }
  return true;
}
